import Copy from "@assets/icons/copy.svg";
import { Button } from "@components/button";
import { BaseInput, Input } from "@components/input";
import { useAuth } from "@features/auth";
import { EnrollmentOtpForm as EnrollmentOtpFormType } from "@features/auth/api";
import { copyToClipboard } from "@helpers/utilities";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import QRCode from "react-qr-code";
import { enrollmentOtpschema } from "../schemes";
import styles from "./login.module.scss";

const extractSecretFromOtpAuthUrl = (otpAuthUrl: string) => {
  const url = new URL(otpAuthUrl.replace("otpauth", "https"));
  return url.searchParams.get("secret");
};

export const EnrollmentOtpForm = () => {
  const { enrollmentOtp, state } = useAuth();

  const { control, handleSubmit, setError, formState } =
    useForm<EnrollmentOtpFormType>({
      resolver: yupResolver(enrollmentOtpschema),
      defaultValues: { code: "" },
    });

  const onSubmit = async (data: EnrollmentOtpFormType) => {
    try {
      await enrollmentOtp(data);
    } catch (error) {
      switch (error) {
        case "INVALID_CODE":
          setError("code", {
            type: "server",
            message: "Неверный код. Попробуйте снова",
          });
          break;
      }
    }
  };
  const secret = extractSecretFromOtpAuthUrl(state.qrCodeUrl || "");

  return (
    <form className={styles.form}>
      {state.qrCodeUrl && secret && (
        <>
          <div className={styles.qrCode}>
            <QRCode value={state.qrCodeUrl} />
          </div>
          <BaseInput
            label="Код 2fa"
            value={secret}
            className={styles.input2fa}
            icon={<Copy />}
            onClick={() => {
              copyToClipboard(secret);
            }}
          />
        </>
      )}

      <Input
        label="Одноразовый код"
        name="code"
        control={control}
        placeholder="Введите одноразовый код"
        className={styles.input}
      />
      <Button
        className={styles.button}
        onClick={handleSubmit(onSubmit)}
        disabled={formState.isSubmitting}
      >
        Войти
      </Button>
    </form>
  );
};
